export default "__VITE_ASSET__u7i5Gl50__"